import React from 'react';
import { RouteComponentProps, useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Button, CircularProgress } from '@mui/material';
import { ParamsProps } from 'src/app/common/components/ParamsProvider';
import { useDetailPage } from './detail-page.hook';
import { Page, PageTitle } from 'src/app/common/components/page/page.component';
import HeaderBreadCrumbs from 'src/app/common/components/layout/components/container/components/header/header-breadcrumbs';
import { CampaignDetailViewComponent } from '../../../components/campaign-detail-view/campaign-detail-view.component';
import { MassCampaignLeadListComponent } from './mass-campaign-lead-list/mass-campaign-lead-list.component';
import { OperationContext } from 'src/app/modules/Leads/components/lead-list-item/lead-operation-units/util/operation-context.util';

type PageProps = ParamsProps &
  RouteComponentProps & {
    /* otherProp: string */
  };

export const DetailPagePage: React.FC<PageProps> = (props: PageProps) => {
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });
  const { id } = useParams<{ id: string }>();

  const { loading, data, navToList, oppProviderValue } = useDetailPage({ id: id });

  return (
    <Page>
      <HeaderBreadCrumbs />
      <PageTitle
        title={Translation('campaign.detail_title')}
        rightNode={
          <Button variant="outlined" color="inherit" onClick={navToList}>
            {Translation('app.button.back')}
          </Button>
        }
      />
      {loading ? (
        <div className="tw-flex tw-justify-center tw-items-center">
          <CircularProgress color="secondary" />
        </div>
      ) : (
        <div>
          <CampaignDetailViewComponent campaignDetail={data} />
          <OperationContext.Provider value={oppProviderValue}>
            <div className="tw-mt-5">
              <MassCampaignLeadListComponent />
            </div>
          </OperationContext.Provider>
        </div>
      )}
    </Page>
  );
};
